import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/blog/authors/[name]/page.client.tsx");
